











import DisponibilitesCalendar from "./DisponibilitesPartials/DisponibilitesCalendar.vue";

export default {
    name: "Disponibilites",
    components: { DisponibilitesCalendar },
};
